import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';

import type { TStClickRequest, TStClickResponse, TStPostbackRequest } from '../types';

export const stTrackingApi = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    stTrackingClick: build.mutation<TStClickResponse, TStClickRequest>({
      query: ({ affId, offerId, rootTransactionId }) => ({
        url: BFF_API_ROUTES.stTrackingClick,
        method: 'GET',
        params: {
          aff_id: affId,
          aff_offer_id: offerId,
          root_transaction_id: rootTransactionId,
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
    stTrackingPostback: build.mutation<void, TStPostbackRequest>({
      query: ({ transactionId, goalName, fullName, mobilePhone, scorePoint }) => ({
        url: BFF_API_ROUTES.stTrackingPostback,
        method: 'GET',
        params: {
          transaction_id: transactionId,
          goal_name: goalName,
          fullName,
          mobilePhone,
          scorePoint,
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});
